__turbopack_context__.v({
  "className": "c-shoG_className",
  "variable": "c-shoG_variable",
});
